import { For, Show, type JSX } from 'solid-js'

import Css from './tabs.module.scss'

/**
 * Uma aba, como a view precisa dela.
 *
 * Forma PLANA, e nao o scope: duas telas desenham abas e cada uma tem o scope dela
 * (`CompanyTabScope`, `MyDataTabScope`). Receber a forma minima permite as duas
 * usarem o mesmo desenho sem que uma precise conhecer o vocabulario da outra - e a
 * mesma decisao do `ChoiceOption` nos filtros.
 */
export type TabItem = {
    key: string
    label: string
    active: boolean

    /** Quantos itens a aba tem. Zero nao desenha nada. */
    badge?: number

    onSelect: () => void
}

/**
 * A barra de abas do painel.
 *
 * Cada aba e um lugar onde o leitor esta - quem as desenha guarda a escolha num
 * parametro de place, nao em estado de componente. Por isso nao ha `useState` aqui:
 * quem manda e o `active` que chega.
 */
export function Tabs(props: { items: TabItem[]; class?: string }): JSX.Element {
    return (
        <div class={`${Css.bar} ${props.class ?? ''}`} role="tablist">
            <For each={props.items}>
                {(item) => (
                    <button
                        type="button"
                        role="tab"
                        aria-selected={item.active}
                        onClick={item.onSelect}
                        class={Css.tab}
                        /*
                            Chave COMPUTADA, porque o nome real tem hash.
                            `Css.active` e `_active_1f3a9_47` depois do build, e
                            escrever `'active'` aqui casaria com nada.
                        */
                        classList={{ [Css.active]: item.active }}
                    >
                        {item.label}
                        {/*
                            O contador aparece na aba FECHADA de proposito: e ele que
                            faz alguem ir ate la. Um numero que so surgisse depois do
                            clique nao avisaria nada.

                            Ele nao repete a condicao da aba: quem decide a cor dele e
                            o `.tab.active &` no SCSS, que e onde essa dependencia
                            fica dita uma vez so.
                        */}
                        <Show when={(item.badge ?? 0) > 0}>
                            <span class={Css.badge}>{item.badge}</span>
                        </Show>
                    </button>
                )}
            </For>
        </div>
    )
}
